import { capitalizeFirstLetter } from 'utils/capitalize-first-letter';

import type { DraftSteps } from './types';

type FormedStepErrorResponse =
  | {
      ok: false;
    }
  | {
      ok: true;
      fields: {
        fullName: string;
        message: string;
      }[];
    };

export const parseFormStepError = (
  errorResponse: unknown,
  currentStep: DraftSteps
): FormedStepErrorResponse => {
  // errorResponse is on the form:
  //   {
  //     "error": {
  //         "creditor_account": {
  //             "iban": [
  //                 "can't be used to send money to FR"
  //             ]
  //         }
  //     }
  // }
  // Sadly, the returned error type is not properly defined,
  // so we have to manually create/check the object

  if (
    !errorResponse ||
    typeof errorResponse !== 'object' ||
    'error' in errorResponse === false ||
    !errorResponse['error'] ||
    typeof errorResponse['error'] !== 'object' ||
    currentStep in errorResponse['error'] === false
  ) {
    return {
      ok: false
    };
  }

  const error = errorResponse['error'][currentStep];

  const errorFields = Object.entries(error) as [string, string[]][];

  const formattedFields = errorFields.map(([field, message]) => {
    return {
      fullName: `${currentStep}.${field}`,
      message: message.map(capitalizeFirstLetter).join('. ')
    };
  });

  return {
    ok: true,
    fields: formattedFields
  };
};
